import React from 'react'

export const IframePowerBi = (props) => {
  return (
    <iframe
        title={props.title}
        style={props.style}
        src={props.src}
        allowFullScreen
    />
  )
}